module.exports = __webpack_public_path__ + "img/3. Our services.20f408cb.png";